<script lang="ts">
    import RiveAnimationsPreloader from '../animations/rive-animations-preloader.svelte';

    export let assets = [];

    let plinkoAssets = Object.values({
        pin: './assets/square_plinko/textures/pin.png',
        ball: './assets/square_plinko/textures/ball.png',
        bg: './assets/square_plinko/textures/bg.webp',
        basket0: './assets/square_plinko/textures/basket_grey.png',
        basket1: './assets/square_plinko/textures/basket_blue.png',
        basket2: './assets/square_plinko/textures/basket_green.png',
        basket3: './assets/square_plinko/textures/basket_pink.png',
        basket4: './assets/square_plinko/textures/basket_red.png',
        basket5: './assets/square_plinko/textures/basket_yellow.png',
        bcomma: './assets/square_plinko/textures/basket_font/comma.png',
        bx: './assets/square_plinko/textures/basket_font/x.png',
        b1: './assets/square_plinko/textures/basket_font/1.png',
        b2: './assets/square_plinko/textures/basket_font/2.png',
        b3: './assets/square_plinko/textures/basket_font/3.png',
        b4: './assets/square_plinko/textures/basket_font/4.png',
        b5: './assets/square_plinko/textures/basket_font/5.png',
        b6: './assets/square_plinko/textures/basket_font/6.png',
        b7: './assets/square_plinko/textures/basket_font/7.png',
        b8: './assets/square_plinko/textures/basket_font/8.png',
        b9: './assets/square_plinko/textures/basket_font/9.png',
        b0: './assets/square_plinko/textures/basket_font/0.png'
    });

    const isImage = asset => /\.(png|jpg|jpeg|webp|svg)$/gi.test(asset.url);

    $: images = assets.filter(isImage);
</script>

<svelte:head>
    {#each images as image (image.url)}
        <link rel="preload" href={image.url} as="image" />
    {/each}
    {#each plinkoAssets as url}
        <link rel="preload" href={url} as="image" />
    {/each}
</svelte:head>

<RiveAnimationsPreloader />
